import { MpItem, MpItemCondition } from 'models/mp/MpItem';
import { PaginationResponse } from 'models/common/Pagination';
import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import {
  MpItemTodoList,
  MpItemTracking,
  MpItemTrackingCondition,
} from '../../models/mp/MpTracking';
import { MpResult } from '../../models/mp/MpResult';
import { MpItemCop } from '../../models/mp/MpItemCop';

/**
 * MP 진행 현황 조회
 * @param condition
 */
export const selectMpTracking = async (condition?: MpItemCondition) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/mp/selectMpTracking`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };

  const response: CommonResponse<PaginationResponse<any>> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as PaginationResponse<any>;
};

/**
 * MP ITEM 진행 필요 목록 조회
 * @param condition
 */
export const findMpItemTodoList = async (condition?: MpItemTrackingCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/findMpItemTodoList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<MpItemTodoList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MpItemTodoList[];
};

export const findMpProgressSummaryItem = async (searchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/findMpProgressSummaryItem`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<any> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as any;
};

export const findMpProgressSummaryPlnt = async (searchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/findMpProgressSummaryPlnt`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<any> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as any;
};

export const saveMpSftyClsf = async (mpSftyClsf: MpItemTracking[]) => {
  console.log(mpSftyClsf);
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/mp/saveMpSftyClsf`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: mpSftyClsf,
  };

  const response: CommonResponse = await callApi(request);
  return response;
};

/**
 *  MP품목상태변경이력
 * @param condition
 */
export const findTrackingStatHis = async (condition?: MpItemCondition) => {
  console.log('findTrackingStatHis', condition);
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/findTrackingStatHis`,
    serviceName: ServiceName.ELM_BE,
    //bodyParams: condition,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<MpItem[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : []) as MpItem[];
};

/**
 * MP 진행 현황 조회(수평전개다운로드)
 * @param condition
 */
export const findTrackingStatHe = async (condition?: MpItemCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/findExcelHe`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<MpItemTracking[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as MpItemTracking[];
};
